module.exports = __webpack_public_path__ + "media/assets/images/icons/patient-page/approved-725d7d9337b736d0dc4d793ad932df54.svg";